<template>
  <div>
  <list
    :filter="filter"
    :active="active"
    :file-type="type"
    :fetch="fetch"
    enable-sort
    :default-sort-by="defaultSortBy"
    :default-columns="defaultFields"
    enable-action
    @act="showFullDetails"/>

    <record-modal
      :record="record"
      :file-type="type"
      :shown="!!record"
      @close="record = null"/>
  </div>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../../utils';
  import {titleCase} from '../Insights/utils';
  import List from '../List';
  import RecordModal from './RecordModal';

  export default {
    name: 'TransactionHistory',

    props: {
      type: String,
      filter: Object | String,
      active: Boolean
    },

    components: {
      List,
      RecordModal
    },

    data() {
      return {
        record: null
      }
    },

    methods: {
      fetch(params) {
        return axios.get(
          fullURL(`/customer-360/${this.filter}/${this.type}`),
          {params}
        )
          .then(({data}) => data);
      },

      knownToSlugs(known) {
        const file = this.$store.getters.getActiveFile(this.type);
        return file && file.entityMap ?
          known.split('|')
            .map(entity => file.entityMap[entity])
            .filter(slug => !!slug) :
          [];
      },

      showFullDetails(record) {
        this.record = record;
      }
    },

    computed: {
      _columns() {
        return this.$store.getters.fileColumns(this.type, true);
      },

      tableFields() {
        return this._columns.map(col => ({
          key: col.slug,
          label: titleCase(col.name),
          sortable: false
        }));
      },

      defaults() {
        if (this.type === 'loans') {
          return {
            sortBy: 'loan_approval_date',
            columns: 'loan_no|loan_amount_disbursed|loan_approval_date|interest_rate|repayment_status'
          };
        }

        return {
          sortBy: 'trans_date',
          columns: 'account_no|trans_amt|trans_date'
        };
      },

      defaultSortBy() {
        return this.knownToSlugs(this.defaults.sortBy)[0];
      },

      defaultFields() {
        return this.knownToSlugs(this.defaults.columns);
      }
    }
  };
</script>
